import React from "react";
import { useTranslation } from "react-i18next";
import { RoomMovie } from "../../../api/room";
import { formatLikeCount } from "../../../utils/helpers";
import styles from "./RoomMovieInfo.module.scss";
import LikeIcon from "../../../components/icons/chat/likeIcon";
import BookMarkIcon from "../../../components/icons/chat/bookMarkIcon";
import ShareIcon from "../../../components/icons/chat/shareIcon";
import {ROUTES} from "../../../constants/routes";
import { useNavigate } from "react-router-dom";
import useInterfaceContext from "../../../components/providers/interface";
import Comments from "../../../components/icons/reactionMenu/Comments";
import {setLastVisitedId} from "../../../store/slices/currentItem.slice";
import {useDispatch} from "react-redux";

interface RoomMovieInfoProps {
  movie: RoomMovie;
  onLike: () => void;
  onDislike: () => void;
  onShare: () => void;
  isLiked: boolean;
  isSwiping: boolean;
  favouritesHandler: (e: any, item: any, isFav: boolean) => void;
  isFavorited: boolean;
  openLoginModal: () => void;
  likesList: number[];
  likeHandler: (e: any, item: any, liked: boolean) => void;
  updateVoteLocal: (id: number, key: "likes_count" | "favorites_count", type: "increment" | "decrement") => void;
}


const RoomMovieInfo: React.FC<RoomMovieInfoProps> = ({ movie, onShare, favouritesHandler, isFavorited, openLoginModal, likesList, likeHandler, updateVoteLocal}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const liked = likesList?.includes(movie.id);

  const likesCount = liked ? movie.likes_count + 1 : movie.likes_count;
  const { isMobile } = useInterfaceContext();
  const clickHandler = () => {
    navigate(`${ROUTES.DETAILS}/${movie.id}`);
    dispatch(setLastVisitedId(movie.id as number));
  };

  const formatCount = (value?: number) => {
    const count = value || 0;
    if (count >= 1000) return `${Math.round(count / 1000)}K`;
    return count;
  };

  const commentsCount = (movie as any).reviews_count ?? (movie as any).comments_count ?? movie.shares_count ?? 0;

  return (

    <>
      <div className={styles.infoBar}>
        <div className={styles.actions}>

          <div
            className={`${styles.actionsItem} ${liked ? styles.actionsItemActive : ""}`}
            onClick={(e) => {
              e.stopPropagation();
              const token = localStorage.getItem("accessToken");
              if (!token) return openLoginModal();
              likeHandler(e, movie, liked);
              updateVoteLocal(movie.id, "likes_count", liked ? "decrement" : "increment");
            }}
          >
            <div className={styles.actionsIcon}><LikeIcon/></div>
            <div className={styles.actionsValue}> {formatLikeCount(likesCount, { compact: true })}</div>
          </div>

          {isMobile && (
            <div
              id="shareDetails"
              className={styles.actionsItem}
              onClick={(e) => {
                clickHandler()
              }}
            >
              <div className={styles.actionsItem}>
                <Comments />
              </div>
              <div className={styles.actionsValue}>{formatCount(commentsCount)}</div>
            </div>
          )}

          <div
            className={`${styles.actionsItem} ${isFavorited ? styles.actionsItemActive : ""}`}
            onClick={(e) => {
              e.stopPropagation();
              const token = localStorage.getItem("accessToken");
              if (!token) return openLoginModal();
              favouritesHandler(e, movie, isFavorited);
              updateVoteLocal(movie.id, "favorites_count", isFavorited ? "decrement" : "increment");
            }}
          >
            <div className={styles.actionsIcon}><BookMarkIcon/></div>
            <div className={styles.actionsValue}>{formatLikeCount(movie.favorites_count, { compact: true })}</div>
          </div>

          {!isMobile && (
            <div
              className={styles.actionsItem}
              onClick={onShare}
            >
              <div className={styles.actionsIcon}><ShareIcon /></div>
              <div className={styles.actionsValue}>{formatLikeCount(movie.shares_count, { compact: true })}</div>
            </div>
          )}

        </div>

        <div className={styles.actionsButtons}>
          <button
            className={styles.actionsButton}
            onClick={() => navigate(`${ROUTES.DETAILS}/${movie.id}`)}
          >
            <span>{t("room_search_movie", "Search movie")}</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default RoomMovieInfo;
